import { useParams } from 'react-router-dom';

const useGetEmployeeId = () => {
  const { id: employeeId } = useParams<{ id: string }>();
  return employeeId;
};
export default useGetEmployeeId;
